import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FaqsComponent } from '../../../../widgets/faqs/faqs.component';
import { FaqItem } from '../../../../core/interface/faq.modal';

@Component({
  selector: 'app-server-monitoring',
  imports: [CommonModule, FeatureHero, FaqsComponent],
  templateUrl: './server-monitoring.html',
  styleUrl: './server-monitoring.scss',
})
export class ServerMonitoring {
  faqs: FaqItem[] = [
    {
      question: 'Why is server monitoring essential?',
      answer: {
        paragraphs: ['Server monitoring is crucial because monitoring not only establishes important statistics about the applications, network, and server but allows software teams to resolve problems much faster. Server monitoring tools help the users to spot and solve any application hosting and performance related issues by hunting down and monitoring server performance. By tracking metrics like disk utilization, CPU usage, and memory allocation, it becomes much easier to spot the foundation or root cause of an issue. The network administrators can fix the problems much faster, which successively reduces downtime and loss of revenue.']
      }
    },
    {
      question: 'What are the various types of server monitoring tools?',
      answer: {
        paragraphs: ['The various types of server monitoring tools include- uptime availability monitoring, site performance monitoring, pesource monitoring, error monitoring, log monitoring, database monitoring and security or malware monitoring. Some of the widespread server monitoring tools which have a huge acceptability within the market are- Sematext, Nagios XI, WhatsUp Gold, Zabbix, Datadog, SolarWinds Server and Application Monitor, Paessler PRTG, OpenNMS, Retrace, Spiceworks Network Monitor, vRealize Hyperic, Icinga, Instrumental, Tornimo etc.']
      }
    },
    {
      question: 'How to find the best server monitoring tool?',
      answer: {
        paragraphs: ["The top server monitoring tools listed above have one goal in common – to monitor the uptime and health of the organization's servers and applications. One can go for the free trials or free versions with limited functionality. Hence, before finding the suitable server monitoring tool for a company's network, the network administrators should try them out before making the payment"]
      }
    }
  ];
}
